import { AddHighlightTypes } from './utils.types';

const addHighlightBold700 = (string: AddHighlightTypes) => {
  return string?.replace(/\[(.*?)\]/g, '<span style="font-weight: 700;">$1</span>') ?? '';
};

export default addHighlightBold700;
